<template>
    <div>
        <vx-input
            v-model="generalPractitioner.name"
            name="general practitioner name"
            placeholder="General Practitioner Name"
            label="General Practitioner Name"
            required
            class="w-full"
            remove-validation-padding
        />
        <div class="flex-col w-full">
            <vx-elastic-suggest
                name="primary practice"
                v-model="generalPractitioner.primaryPractice"
                class="aggregator"
                :showOnFocus="true"
                :search_groups="practice_list"
                clearable
                label="Primary Practice"
                required
            ></vx-elastic-suggest>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'general-practitioner-form',
    components: {},
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            prefilledFormData: null,
            practice_list: {
                Practices: {
                    searchUrl: '/maarima/Practice',
                    idfield: 'id',
                    searchOn: (b) => `${b.name}`,
                    displayText: 'name'
                }
            }
        }
    },
    watch: {},
    computed: {
        ...mapGetters({
            practices: 'maarima/practices'
        }),
        generalPractitioner: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    }
}
</script>
